<div class="layout-topbar">
  <div>
    <a class="layout-topbar-logo" routerLink="">
      
      <span>Observation</span>
    </a>
  </div>

  <a class="p-link layout-menu-button layout-topbar-button" (click)="contentLayout.toggleMenu($event)">
    <i class="pi pi-bars"></i>
  </a>

  <a
    class="p-link layout-topbar-mobile-menu-button layout-topbar-button"
    (click)="contentLayout.toggleMobileTopMenu($event)"
  >
    <i class="pi pi-ellipsis-v"></i>
  </a>

  <div class="layout-topbar-menu" [ngClass]="{ 'layout-topbar-menu-mobile-active': contentLayout.topMobileMenuActive }">
    <span
      class="p-link layout-topbar-button"
      (click)="this.contentLayout.toggleSidebarDisplay($event, 'SidebarNotificationsComponent')"
    >
      <i
        *ngIf="(contentLayout.messageBusService.messages$ | async).length > 0"
        class="pi pi-bell"
        pBadge
        [value]="(contentLayout.messageBusService.messages$ | async).length.toString()"
      ></i>
      <i *ngIf="(contentLayout.messageBusService.messages$ | async).length === 0" class="pi pi-bell"></i>
      <span class="pl-2">Notifications</span>
    </span>

    <span
      class="p-link layout-topbar-button"
      (click)="this.contentLayout.toggleSidebarDisplay($event, 'SidebarThemeConfigComponent')"
    >
      <i class="fa-solid fa-gear fa-xl"></i>
      <span class="pl-2">Theme Settings</span>
    </span>

    <span
      class="p-link layout-topbar-button"
      (click)="this.contentLayout.toggleSidebarDisplay($event, 'SidebarProfileComponent')"
    >
      <div class="text-2xl font-medium text-color">
        <div *ngIf="this.contentLayout.currentlyAuthorizedUserService.user$ | async as user">
          {{ user.firstName?.charAt(0) + user.lastName?.charAt(0) }}
        </div>
      </div>
      <span class="pl-2">Profile</span>
    </span>
  </div>
</div>
